'use client'

import { useTranslations } from 'next-intl'
import Link from 'next/link'
import InfoCard from './info-card'
import SectionHeader from './section-header'

export default function EnvironmentalResponsibility() {
  const t = useTranslations('page_cam_ket_phat_trien')
  return (
    <div id='item-1-content'>
      <SectionHeader number='01' title={t('environment.title')} />
      <div className='grid gap-5 md:grid-cols-3'>
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip9_58.png'
          imageAlt={t('environment.card_1.alt')}
          title={t('environment.card_1.title')}
          description={
            <>
              {t('environment.card_1.description_prefix')}{' '}
              <Link
                href='/post/vai-polyester-la-gi#b-heading-H2-4'
                className='font-bold text-primary underline'
              >
                {t('environment.card_1.link_text')}
              </Link>{' '}
              {t('environment.card_1.description_suffix')}
            </>
          }
        />
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip10_40.png'
          imageAlt={t('environment.card_2.alt')}
          title={t('environment.card_2.title')}
          description={t('environment.card_2.description')}
        />
        <InfoCard
          imageSrc='https://media.coolmate.me/image/October2024/mceclip11_44.png'
          imageAlt={t('environment.card_3.alt')}
          title={t('environment.card_3.title')}
          description={
            <>
              {t('environment.card_3.description_prefix')}{' '}
              <Link
                href='/post/soi-sorona-la-gi'
                className='font-bold text-primary underline'
              >
                {t('environment.card_3.link_1_text')}
              </Link>{' '}
              {t('environment.card_3.link_1_suffix')}{' '}
              <Link
                href='/post/vai-ca-phe-la-gi-nhung-dac-diem-noi-bat-cua-vai-soi-ca-phe'
                className='font-bold text-primary underline'
              >
                {t('environment.card_3.link_2_text')}
              </Link>
              {t('environment.card_3.link_2_suffix')}
            </>
          }
        />
      </div>
    </div>
  )
}
